export default class Popup {
	constructor() {
		this.modal = document.querySelector('[data-popup]');
		if (!this.modal) return;

		this.focusableSelectors = 'a, button, textarea, input, select';
		this.initialized = false;

		this.init();
	}

	init() {
		if (this.initialized) return;
		this.initialized = true;

		this.bindEvents();

		// Show once per session (tab)
		if (sessionStorage.getItem('popupShown')) return;

		this.open();
	}

	bindEvents() {
		this.modal.addEventListener('click', (e) => {
			if (e.target.hasAttribute('data-close')) {
				this.close();
			}
		});

		// Keyboard handling
		document.addEventListener('keydown', (e) => {
			if (!this.isOpen()) return;

			if (e.key === 'Escape') {
				this.close();
			}

			if (e.key === 'Tab') {
				this.trapFocus(e);
			}
		});
	}

	open() {
		this.modal.hidden = false;

		sessionStorage.setItem('popupShown', 'true');

		this.focusable = this.modal.querySelectorAll(this.focusableSelectors);
		this.first = this.focusable[0];
		this.last = this.focusable[this.focusable.length - 1];

		if (this.first) {
			this.first.focus();
		}
	}

	close() {
		this.modal.hidden = true;
	}

	isOpen() {
		return !this.modal.hidden;
	}

	trapFocus(e) {
		if (!this.focusable || !this.focusable.length) return;

		if (e.shiftKey) {
			if (document.activeElement === this.first) {
				e.preventDefault();
				this.last.focus();
			}
		} else {
			if (document.activeElement === this.last) {
				e.preventDefault();
				this.first.focus();
			}
		}
	}
}
